import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";

const GroupsSitesTemplate = ({ groups, applicationCount }: IUserStatusViewModel) => (
  <span data-testid="groupsApplications" className="title">
    {groups ? groups.length : 0}
    {" "}
    /
    {" "}
    {applicationCount}
  </span>
);

export default GroupsSitesTemplate;
